

















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { IdCodNomeDTO } from '@/interfaces/base-dto';
import { getAvailableTemplatesClientsUnit } from '@/services/client-unit';

@Component({
  components: { PermissionAuth },
})
export default class ClientUnitTemplates extends BaseComponent {
  @Prop()
  public value: IdCodNomeDTO[];
  @Prop({
    default: false,
  })
  public isEdit: boolean;

  public templates: any[] = [];
  public selectedTemplates: IdCodNomeDTO[] = [];
  private templateAdd: any = null;
  private loading: boolean = false;

  public headers: any = [
    { text: 'Código', value: 'codigo', sortable: true },
    { text: 'Nome', value: 'nome', align: 'left', sortable: true },
    { text: 'Ações', value: 'actions', align: 'right', sortable: false },
  ];

  @Watch('value')
  public onValueChange(val): void {
    this.selectedTemplates = val;
  }

  @Watch('selectedTemplates')
  public onSelectedTemplatesChange(val): void {
    this.$emit('input', val);
  }

  public beforeMount() {
    this.getTemplates();
  }

  private getTemplates(): void {
    this.loading = true;
    getAvailableTemplatesClientsUnit().subscribe(
      (list) => {
        this.loading = false;
        this.templates = list.map((item) => {
          return {
            id: item.id,
            descricaofull: item.codigo + ' - ' + item.nome,
            codigo: item.codigo,
            nome: item.nome,
          };
        });
      },
      (error) => {
        this.loading = false;
      },
    );
  }

  private getAvailableItems(): any[] {
    return this.templates.filter((t) => !this.selectedTemplates.filter((st) => st != null && st.id == t.id).length);
  }

  private addTemp() {
    this.selectedTemplates.push(this.templateAdd);
    setTimeout(() => {
      this.onSelectedTemplatesChange(this.selectedTemplates);
      this.templateAdd = null;
    }, 200);
  }

  private deleteTemp(temp) {
    this.selectedTemplates.splice(this.selectedTemplates.indexOf(temp), 1);
    setTimeout(() => {
      this.onSelectedTemplatesChange(this.selectedTemplates);
    }, 200);
  }
}
